
import { useEffect, useRef, useState } from 'react';

const Education = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const education = [
    {
      degree: 'Bachelor of Agriculture Honours',
      institution: 'University of KwaZulu-Natal',
      year: '2021',
      description: 'Advanced studies in agricultural sciences with focus on sustainable farming practices and agricultural innovation.',
      icon: 'ri-graduation-cap-line'
    },
    {
      degree: 'Bachelor of Agriculture',
      institution: 'University of KwaZulu-Natal',
      year: '2020',
      description: 'Comprehensive foundation in agricultural principles, crop science, animal husbandry, and farm management.',
      icon: 'ri-book-open-line'
    },
    {
      degree: 'National Senior Certificate',
      institution: 'Raisethorpe Secondary School',
      year: '2015',
      description: 'Completed secondary education with strong performance in mathematics and natural sciences.',
      icon: 'ri-school-line'
    }
  ];

  return (
    <section id="education" ref={sectionRef} className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
          <div className="text-center mb-8 md:mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 md:mb-6 font-serif">
              Education
            </h2>
            <div className="w-24 h-1 bg-green-600 mx-auto mb-4 md:mb-6"></div>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Academic foundation built through rigorous study and practical application in agricultural sciences.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {education.map((edu, index) => (
              <div
                key={index}
                className={`bg-white p-6 md:p-8 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-2 transition-all duration-300 cursor-pointer ${
                  isVisible ? 'animate-fade-in-up' : ''
                }`}
                style={{ animationDelay: `${index * 150}ms` }}
              >
                <div className="text-center mb-4 md:mb-6">
                  <div className="w-12 h-12 md:w-16 md:h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3 md:mb-4">
                    <i className={`${edu.icon} text-2xl md:text-3xl text-green-600`}></i>
                  </div>
                  <div className="text-xl md:text-2xl font-bold text-green-600 mb-2">{edu.year}</div>
                </div>
                
                <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2 text-center">
                  {edu.degree}
                </h3>
                
                <p className="text-green-600 font-medium text-center mb-3 md:mb-4 text-sm md:text-base">
                  {edu.institution}
                </p>
                
                <p className="text-gray-600 text-xs md:text-sm text-center leading-relaxed">
                  {edu.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
